import { render } from "./AposLayoutColControlDialog.vue?vue&type=template&id=04ad7454&scoped=true"
import script from "./AposLayoutColControlDialog.vue?vue&type=script&lang=js"
export * from "./AposLayoutColControlDialog.vue?vue&type=script&lang=js"

import "./AposLayoutColControlDialog.vue?vue&type=style&index=0&id=04ad7454&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ad7454"],['__file',"layout-widget/ui/apos/components/AposLayoutColControlDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04ad7454"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04ad7454', __exports__)) {
    api.reload('04ad7454', __exports__)
  }
  
  module.hot.accept("./AposLayoutColControlDialog.vue?vue&type=template&id=04ad7454&scoped=true", () => {
    api.rerender('04ad7454', render)
  })

}


export default __exports__